// extracted by mini-css-extract-plugin
module.exports = {"show-xs":"index_show-xs_3hBCO","hide-xs":"index_hide-xs_3KyOY","dropdown":"index_dropdown_5m6UT"};